// removed by extract-text-webpack-plugin
module.exports = {"containerSlider":"_2OaFgJuBaYrPo_bd6H43Vg","arrowDesktop":"EvRISwHI7CqRM0vWYNT8B","buttonWrapper":"lyGxxeCTw_Lghry28ZjLV","mobileWrapper":"_1GFszI4WCs2fVRkWoG3w4p","slicSlider":"_3T1Z5lwxvhSXGIPhuItI7v","sliderWrapper":"_3p1kw2fyFt0qz0bgdicVT_","slick-active":"_1VbL63OTpZIl6hZG9zmZru","slick-slider":"_3JAgDdgOc5jWTuHHuuemSe","slick-initialized":"g0_CM17HtkCSZaOf2OGt","desktopWrapper":"_2xGPt30XE1qf_dgQ-r4vg7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingSliderPhoto/LandingSliderPhoto.scss
// module id = 1619
// module chunks = 0